"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import { Text } from '../../../Text/Text.mjs';
import styles from '../../FileCard.module.scss.mjs';

const FileSizeText = (props) => {
  const { sizeInBytes } = props;
  return /* @__PURE__ */ jsx(Text, { className: styles.subTitle, children: new Intl.NumberFormat(void 0, {
    notation: "compact",
    style: "unit",
    unit: "byte",
    unitDisplay: "narrow"
  }).format(sizeInBytes) });
};

export { FileSizeText, FileSizeText as default };
//# sourceMappingURL=FileSizeText.mjs.map
